import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestTemplatesBlockerUseGet = {
    path: "/templates/blocker/:identifier",
    method: RouteHttpVerb.GET,
    obfuscatePath: "full"
};
